import React from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles({
  labelMarker: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#fff',
    zIndex: 1,
  },
  iconMarker: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    width: '34px',
    height: '34px',
    color: '#fff',
    filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.2))',
    borderRadius: '50%',
    borderWidth: '2px',
    borderStyle: 'solid',
    zIndex: 2,
  },
  campus: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    width: '120px',
    height: '52px',
  },
  entranceBottom: {
    position: 'absolute',
    cursor: 'pointer',
    width: '100px',
    height: '28px',
    transform: 'translate(-15%, 3px)',
  },
  entranceRight: {
    position: 'absolute',
    cursor: 'pointer',
    width: '100px',
    height: '28px',
    transform: 'translate(0, -50%)',
  },
  popper: {
    position: 'absolute',
    width: '200px',
    left: 0,
    bottom: '1.6rem',
    transform: 'translateX(-50%)',
    padding: '1rem',
    zIndex: 3,
    '&::after': {
      background: 'white',
      boxShadow: '-2px 2px 2px 0 rgba(178, 178, 178, 0.4)',
      content: '',
      height: '15px',
      left: '50%',
      position: 'absolute',
      bottom: 0,
      transform: 'translate(-50%, 50%) rotate(-45deg)',
      width: '15px',
    },
  },
  close: {
    position: 'absolute',
    top: 0,
    right: 0,
    cursor: 'pointer',
  },
});

const Marker = ({ name, marker, popperOpen, closePopper, zoom }) => {
  const classes = useStyles();
  const { label, icon, area, info, cssClassName } = marker;

  let target = null;

  if (area) {
    // 360 tour marker
    target = (
      <Link to={`/maps/${name}/${area}/`}>
        <img src={icon} className={classes.iconMarker} alt={area} />
      </Link>
    );
  } else if (label) {
    // area label or parking lot label
    let labelStyle = { fontSize: '24px' };
    switch (label) {
      case 'South Gym':
      case 'North Gym':
      case 'N':
        labelStyle = { fontSize: '16px', textAlign: 'center' };
        break;
      case 'W':
        if (info) {
          labelStyle = { fontSize: '12px' };
        }
        break;
      case 'Greenhouse':
        labelStyle = { fontSize: `${7 + (zoom - 17) * 4}px` };
        break;
      default:
        labelStyle = { fontSize: '24px' };
    }
    target = (
      <span className={classes.labelMarker} style={labelStyle}>
        {label}
      </span>
    );
  } else if (icon) {
    const className = cssClassName ? cssClassName : 'iconMarker';
    target = <img src={icon} className={classes[className]} alt={info} />;
  }

  return (
    <div>
      {target}
      {popperOpen && (
        <Paper className={classes.popper}>
          <CloseIcon className={classes.close} onClick={closePopper} />
          <Typography>{info}</Typography>
        </Paper>
      )}
    </div>
  );
};

export default Marker;
